export const SET_PAGE_NAME = "SET_PAGE_NAME";
export const SET_PAGE_NAME_SUCCESS = "SET_PAGE_NAME_SUCCESS";
export const SET_PAGE_NAME_FAILED = "SET_PAGE_NAME_FAILED";

export const FETCH_AUDIO_TRACKS = "FETCH_AUDIO_TRACKS";
export const FETCH_AUDIO_TRACKS_SUCCESS = "FETCH_AUDIO_TRACKS_SUCCESS";
export const FETCH_AUDIO_TRACKS_FAILED = "FETCH_AUDIO_TRACKS_FAILED";

export const SAVE_AUDIO_TRACKS_TRANSCRIPT = "SAVE_AUDIO_TRACKS_TRANSCRIPT";
export const SAVE_AUDIO_TRACKS_TRANSCRIPT_SUCCESS =
  "SAVE_AUDIO_TRACKS_TRANSCRIPT_SUCCESS";
export const SAVE_AUDIO_TRACKS_TRANSCRIPT_FAILED =
  "SAVE_AUDIO_TRACKS_TRANSCRIPT_FAILED";

export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";

export const REGISTER = "REGISTER";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAILED = "REGISTER_FAILED";

export const GET_COLLEGE_LIST = "GET_COLLEGE_LIST";
export const GET_COLLEGE_LIST_SUCCESS = "GET_COLLEGE_LIST_SUCCESS";
export const GET_COLLEGE_LIST_FAILED = "GET_COLLEGE_LIST_FAILED";

export const GET_USER_REPORT = "GET_USER_REPORT";
export const GET_USER_REPORT_SUCCESS = "GET_USER_REPORT_SUCCESS";
export const GET_USER_REPORT_FAILED = "GET_USER_REPORT_FAILED";

export const FETCH_TRAINED_SENTENCE_COUNT_REPORT =
  "FETCH_TRAINED_SENTENCE_COUNT_REPORT";
export const FETCH_TRAINED_SENTENCE_COUNT_REPORT_SUCCESS =
  "FETCH_TRAINED_SENTENCE_COUNT_REPORT_SUCCESS";
export const FETCH_TRAINED_SENTENCE_COUNT_REPORT_FAILED =
  "FETCH_TRAINED_SENTENCE_COUNT_REPORT_FAILED";

export const FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT =
  "FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT";
export const FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT_SUCCESS =
  "FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT_SUCCESS";
export const FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT_FAILED =
  "FETCH_TRANSCRIPTED_SENTENCE_COUNT_REPORT_FAILED";

export const FETCH_COMPARED_STATISTIC_REPORT =
  "FETCH_COMPARED_STATISTIC_REPORT";
export const FETCH_COMPARED_STATISTIC_REPORT_SUCCESS =
  "FETCH_COMPARED_STATISTIC_REPORT_SUCCESS";
export const FETCH_COMPARED_STATISTIC_REPORT_FAILED =
  "FETCH_COMPARED_STATISTIC_REPORT_FAILED";

export const FETCH_SPECIFIC_AUDIO = "FETCH_SPECIFIC_AUDIO";
export const FETCH_SPECIFIC_AUDIO_SUCCESS = "FETCH_SPECIFIC_AUDIO_SUCCESS";
export const FETCH_SPECIFIC_AUDIO_FAILED = "FETCH_SPECIFIC_AUDIO_FAILED";

export const GET_TRANSCRIPT_LIST_TO_BE_RECORDED =
  "GET_TRANSCRIPT_LIST_TO_BE_RECORDED";
export const GET_TRANSCRIPT_LIST_TO_BE_RECORDED_FAILED =
  "GET_TRANSCRIPT_LIST_TO_BE_RECORDED_FAILED";
export const GET_TRANSCRIPT_LIST_TO_BE_RECORDED_SUCCESS =
  "GET_TRANSCRIPT_LIST_TO_BE_RECORDED_SUCCESS";

export const UPLOAD_FILE_REQUEST = "UPLOAD_FILE_REQUEST";
export const UPLOAD_FILE_REQUEST_SUCCESS = "UPLOAD_FILE_REQUEST_SUCCESS";
export const UPLOAD_FILE_REQUEST_FAILED = "UPLOAD_FILE_REQUEST_FAILED";

export const DOWNLOAD_HOURLY_REPORT = "DOWNLOAD_HOURLY_REPORT";
export const DOWNLOAD_HOURLY_REPORT_SUCCESS = "DOWNLOAD_HOURLY_REPORT_SUCCESS";
export const DOWNLOAD_HOURLY_REPORT_FAILED = "DOWNLOAD_HOURLY_REPORT_FAILED";

export const DOWNLOAD_RECORDING_PENDING_REPORT =
  "DOWNLOAD_RECORDING_PENDING_REPORT";
export const DOWNLOAD_RECORDING_PENDING_REPORT_SUCCESS =
  "DOWNLOAD_RECORDING_PENDING_REPORT_SUCCESS";
export const DOWNLOAD_RECORDING_PENDING_REPORT_FAILED =
  "DOWNLOAD_RECORDING_PENDING_REPORT_FAILED";

export const DOWNLOAD_CSV_FILE = "DOWNLOAD_CSV_FILE";
export const DOWNLOAD_CSV_FILE_SUCCESS = "DOWNLOAD_CSV_FILE_SUCCESS";
export const DOWNLOAD_CSV_FILE_FAILED = "DOWNLOAD_CSV_FILE_FAILED";

export const GET_QA_TRANSCRIPTION_FILE = "GET_QA_TRANSCRIPTION_FILE";
export const GET_QA_TRANSCRIPTION_FILE_SUCCESS =
  "GET_QA_TRANSCRIPTION_FILE_SUCCESS";
export const GET_QA_TRANSCRIPTION_FILE_FAILED =
  "GET_QA_TRANSCRIPTION_FILE_FAILED";

export const QA_DESICISION_TRANSCRIPTION_FILE =
  "QA_DESICISION_TRANSCRIPTION_FILE";
export const QA_DESICISION_TRANSCRIPTION_FILE_SUCCESS =
  "QA_DESICISION_TRANSCRIPTION_FILE_SUCCESS";
export const QA_DESICISION_TRANSCRIPTION_FILE_FAILED =
  "QA_DESICISION_TRANSCRIPTION_FILE_FAILED";

export const GET_SUPER_QA_TRANSCRIPTION_FILE =
  "GET_SUPER_QA_TRANSCRIPTION_FILE";
export const GET_SUPER_QA_TRANSCRIPTION_FILE_SUCCESS =
  "GET_SUPER_QA_TRANSCRIPTION_FILE_SUCCESS";
export const GET_SUPER_QA_TRANSCRIPTION_FILE_FAILED =
  "GET_SUPER_QA_TRANSCRIPTION_FILE_FAILED";

export const SUPER_QA_DESICISION_TRANSCRIPTION_FILE =
  "SUPER_QA_DESICISION_TRANSCRIPTION_FILE";
export const SUPER_QA_DESICISION_TRANSCRIPTION_FILE_SUCCESS =
  "SUPER_QA_DESICISION_TRANSCRIPTION_FILE_SUCCESS";
export const SUPER_QA_DESICISION_TRANSCRIPTION_FILE_FAILED =
  "SUPER_QA_DESICISION_TRANSCRIPTION_FILE_FAILED";

export const FETCH_USER_LIST = "FETCH_USER_LIST";
export const FETCH_USER_LIST_SUCCESS = "FETCH_USER_LIST_SUCCESS";
export const FETCH_USER_LIST_FAILED = "FETCH_USER_LIST_FAILED";

export const FETCH_AUDITED_LIST_BY_USER = "FETCH_AUDITED_LIST_BY_USER";
export const FETCH_AUDITED_LIST_BY_USER_SUCCESS =
  "FETCH_AUDITED_LIST_BY_USER_SUCCESS";
export const FETCH_AUDITED_LIST_BY_USER_FAILED =
  "FETCH_AUDITED_LIST_BY_USER_FAILED";

export const FETCH_REJECT_REASON_LIST = "FETCH_REJECT_REASON_LIST";
export const FETCH_REJECT_REASON_LIST_SUCCESS =
  "FETCH_REJECT_REASON_LIST_SUCCESS";
export const FETCH_REJECT_REASON_LIST_FAILED =
  "FETCH_REJECT_REASON_LIST_FAILED";

export const INSERT_NEW_USER = "INSERT_NEW_USER";
export const INSERT_NEW_USER_SUCCESS = "INSERT_NEW_USER_SUCCESS";
export const INSERT_NEW_USER_FAILED = "INSERT_NEW_USER_FAILED";

export const UPDATE_USER_DETAILS = "UPDATE_USER_DETAILS";
export const UPDATE_USER_DETAILS_SUCCESS = "UPDATE_USER_DETAILS_SUCCESS";
export const UPDATE_USER_DETAILS_FAILED = "UPDATE_USER_DETAILS_FAILED";

export const FILE_UPLOAD = "FILE_UPLOAD";
export const FILE_UPLOAD_SUCCESS = "FILE_UPLOAD_SUCCESS";
export const FILE_UPLOAD_FAILED = "FILE_UPLOAD_FAILED";

export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGUT_FAILED = "LOGUT_FAILED";

export const FETCH_DASHBOARD = "FETCH_DASHBOARD";

export const FETCH_DASHBOARD_SUCCESS = "FETCH_DASHBOARD_SUCCESS";
export const FETCH_DASHBOARD_FAILED = "FETCH_DASHBOARD_FAILED";

export const userType = [
  { label: "Recording / Do transcript", value: "1" },
  { label: "Transcript audit", value: "2" },
  { label: "Recording audit", value: "3" },
];

export const lang = [
  { label: "Tamil", value: "Tamil" },
  { label: "Kannada", value: "Kannada" },
  { label: "Malayalam", value: "Malayalam" },
  { label: "Telugu", value: "Telugu" },
  { label: "Hindi", value: "Hindi" },
  { label: "Gujarati", value: "Gujarati" },
  { label: "Marathi", value: "Marathi" },
  { label: "Bengali", value: "Bengali" },
];

export const FETCH_LANGUAGES = "FETCH_LANGUAGES";
export const FETCH_LANGUAGES_SUCCESS = "FETCH_LANGUAGES_SUCCESS";
export const FETCH_LANGUAGES_FAILED = "FETCH_LANGUAGES_FAILED";

export const FETCH_PRODUCTS = "FETCH_PRODUCTS";
export const FETCH_PRODUCTS_SUCCESS = "FETCH_PRODUCTS_SUCCESS";
export const FETCH_PRODUCTS_FAILED = "FETCH_PRODUCTS_FAILED";

export const FETCH_TEAMS = "FETCH_TEAMS";
export const FETCH_TEAMS_SUCCESS = "FETCH_TEAMS_SUCCESS";
export const FETCH_TEAMS_FAILED = "FETCH_TEAMS_FAILED";

export const FETCH_USER_TYPE = "FETCH_USER_TYPE";
export const FETCH_USER_TYPE_SUCCESS = "FETCH_USER_TYPE_SUCCESS";
export const FETCH_USER_TYPE_FAILED = "FETCH_USER_TYPE_FAILED";

export const FETCH_ENGLISH_KEYWORDS = "FETCH_ENGLISH_KEYWORDS";
export const FETCH_ENGLISH_KEYWORDS_SUCCESS = "FETCH_ENGLISH_KEYWORDS_SUCCESS";
export const FETCH_ENGLISH_KEYWORDS_FAILED = "FETCH_ENGLISH_KEYWORDS_FAILED";

export const SAVE_KEYWORDS_SUGGESTIONS = "SAVE_KEYWORDS_SUGGESTIONS";
export const SAVE_KEYWORDS_SUGGESTIONS_SUCCESS =
  "SAVE_KEYWORDS_SUGGESTIONS_SUCCESS";
export const SAVE_KEYWORDS_SUGGESTIONS_FAILED =
  "SAVE_KEYWORDS_SUGGESTIONS_FAILED";
export const SAVE_KEYWORD = "SAVE_KEYWORD";
export const SAVE_KEYWORD_SUCCESS = "SAVE_KEYWORD_SUCCESS";
export const SAVE_KEYWORD_FAILED = "SAVE_KEYWORD_FAILED";

export const FETCH_KEYWORD_AUDIT = "FETCH_KEYWORD_AUDIT";
export const FETCH_KEYWORD_AUDIT_SUCCESS = "FETCH_KEYWORD_AUDIT_SUCCESS";
export const FETCH_KEYWORD_AUDIT_FAILED = "FETCH_KEYWORD_AUDIT_FAILED";

export const FETCH_AUDIT_USER_LIST = "FETCH_AUDIT_USER_LIST";
export const FETCH_AUDIT_USER_LIST_SUCCESS = "FETCH_AUDIT_USER_LIST_SUCCESS";
export const FETCH_AUDIT_USER_LIST_FAILED = "FETCH_AUDIT_USER_LIST_FAILED";

export const FETCH_SPEAKER = "FETCH_SPEAKER";
export const FETCH_SPEAKER_SUCCESS = "FETCH_SPEAKER_SUCCESS";
export const FETCH_SPEAKER_FAILED = "FETCH_SPEAKER_FAILED";

export const SAVE_KEYWORDS_AUDIT = "SAVE_KEYWORDS_AUDIT";
export const SAVE_KEYWORDS_AUDIT_SUCCESS = "SAVE_KEYWORDS_AUDIT_SUCCESS";
export const SAVE_KEYWORDS_AUDIT_FAILED = "SAVE_KEYWORDS_AUDIT_FAILED";

export const GET_QA_AUDIO = "GET_QA_AUDIO";
export const GET_QA_AUDIO_SUCCESS = "GET_QA_AUDIO_SUCCESS";
export const GET_QA_AUDIO_FAILED = "GET_QA_AUDIO_FAILED";

export const GET_SQA_AUDIO = "GET_SQA_AUDIO";
export const GET_SQA_AUDIO_SUCCESS = "GET_SQA_AUDIO_SUCCESS";
export const GET_SQA_AUDIO_FAILED = "GET_SQA_AUDIO_FAILED";

export const QA_DESICISION_AUDIO_FILE = "QA_DESICISION_AUDIO_FILE";
export const QA_DESICISION_AUDIO_FILE_SUCCESS =
  "QA_DESICISION_AUDIO_FILE_SUCCESS";
export const QA_DESICISION_AUDIO_FILE_FAILED =
  "QA_DESICISION_AUDIO_FILE_FAILED";

export const SQA_DESICISION_AUDIO_FILE = "SQA_DESICISION_AUDIO_FILE";
export const SQA_DESICISION_AUDIO_FILE_SUCCESS =
  "SQA_DESICISION_AUDIO_FILE_SUCCESS";
export const SQA_DESICISION_AUDIO_FILE_FAILED =
  "SQA_DESICISION_AUDIO_FILE_FAILED";

export const UPDATE_EXISTING_KEYWORD = "UPDATE_EXISTING_KEYWORD";
export const UPDATE_EXISTING_KEYWORD_SUCCESS =
  "UPDATE_EXISTING_KEYWORD_SUCCESS";
export const UPDATE_EXISTING_KEYWORD_FAILED = "UPDATE_EXISTING_KEYWORD_FAILED";

export const RECORDING_TIME = 15;
export const MAX_FILE_SIZE = 103000;
export const MIN_FILE_SIZE = 5;

//export const API_URL = "http://220.225.104.139:4001"

// export const API_URL = 'http://220.225.104.139:4001';
// export const API_URL = 'http://123.63.108.204:4001';
// export const API_URL = "http://10.101.1.248:4001";
export const API_URL = "https://appserver.armsoft-tech.com";
